import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Tag: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M18.1785 9.37327C18.2637 9.99316 18.0536 10.6174 17.6112 11.0598L10.5711 18.0998C9.79007 18.8809 8.52306 18.8809 7.74201 18.0998L2.08576 12.4436C1.30471 11.6625 1.30471 10.3955 2.08576 9.61448L9.1258 2.57444C9.56823 2.13202 10.1925 1.92195 10.8123 2.00706L16.1619 2.74241C16.8279 2.83414 17.3514 3.35773 17.4432 4.02366L18.1785 9.37327ZM15.1297 7.27562C15.7153 6.68986 15.7153 5.74028 15.1297 5.15452C14.544 4.56877 13.5944 4.56885 13.0086 5.15452C12.4228 5.74031 12.4228 6.68983 13.0086 7.27562C13.5944 7.86127 14.544 7.86136 15.1297 7.27562Z" fillRule="evenodd" />
  </CustomIcon>
);

export default Tag;
